"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var transformation_matrix_1 = require("transformation-matrix");
/**
 * Get the full offset (left, top, width,
 * height, rotation) of an HTML element.
 */
exports.offsetAndSizeOfElement = function (element) { return ({
    left: element.offsetLeft,
    top: element.offsetTop,
    width: element.offsetWidth,
    height: element.offsetHeight,
}); };
/**
 * Get the left and top offsets of an HTML element, relative to its parent.
 */
exports.offsetOfElement = function (element) { return ({
    left: element.offsetLeft,
    top: element.offsetTop,
}); };
/**
 * Get the px size of an HTML element.
 */
exports.sizeOfElement = function (element) { return ({
    width: element.offsetWidth,
    height: element.offsetHeight,
}); };
/**
 * Gets the current rotation of an HTML element.
 */
exports.rotationOfElement = function (element) {
    var tM = exports.transformationMatrixOfElement(element);
    var radians = Math.atan2(tM.b, tM.a);
    return +(radians * (180 / Math.PI)).toFixed(1);
};
/**
 * Get the scale of an HTMLElement. Takes all of its
 * ancestors into account. Assumes x and y scale are equal.
 */
exports.scaleOfElement = function (element) {
    var tM = exports.globalTransformationMatrixOfElement(element);
    var a = tM.a, c = tM.c;
    var scale = Math.sqrt(a * a + c * c);
    return scale;
};
/**
 * Get the transform Matrix object of an element.
 */
exports.transformationMatrixOfElement = function (element) {
    return transformation_matrix_1.fromString(exports.transformationMatrixStringOfElement(element));
};
/**
 * The cumulative transformation matrix of an element's
 * transforms and all of its ancestors' transforms.
 */
exports.globalTransformationMatrixOfElement = function (element) {
    var tM = exports.transformationMatrixOfElement(element);
    if (element.parentElement) {
        var parentTM = exports.globalTransformationMatrixOfElement(element.parentElement);
        return transformation_matrix_1.transform(tM, parentTM);
    }
    return tM;
};
// Identity Matrix. Applying this results in no transformations.
var IDENTITY_MATRIX_STRING = 'matrix(1, 0, 0, 1, 0, 0)';
/*
 * Cross browser way to get the current transformation matrix of an Element.
 */
exports.transformationMatrixStringOfElement = function (element) {
    var style = window.getComputedStyle(element, null);
    var result = style.getPropertyValue('-webkit-transform') ||
        style.getPropertyValue('-moz-transform') ||
        style.getPropertyValue('-ms-transform') ||
        style.getPropertyValue('-o-transform') ||
        style.getPropertyValue('transform') ||
        IDENTITY_MATRIX_STRING;
    if (result === 'none') {
        return IDENTITY_MATRIX_STRING;
    }
    return result;
};
/**
 * Calculate where the four corners of an HTML Element
 * will be after applying CSS transformations.
 */
exports.visualCorners = function (offsetAndSize, tm) {
    var halfWidth = offsetAndSize.width / 2;
    var halfHeight = offsetAndSize.height / 2;
    // Assume the center of the Element is (0, 0).
    var nw = { x: -halfWidth, y: -halfHeight };
    var ne = { x: halfWidth, y: -halfHeight };
    var sw = { x: -halfWidth, y: halfHeight };
    var se = { x: halfWidth, y: halfHeight };
    // New location of above points after applying transformation matrix.
    var tnw = transformation_matrix_1.applyToPoint(tm, nw);
    var tne = transformation_matrix_1.applyToPoint(tm, ne);
    var tsw = transformation_matrix_1.applyToPoint(tm, sw);
    var tse = transformation_matrix_1.applyToPoint(tm, se);
    // "Move" center of Element back to its original offset.
    return {
        nw: {
            x: tnw.x + halfWidth + offsetAndSize.left,
            y: tnw.y + halfHeight + offsetAndSize.top,
        },
        ne: {
            x: tne.x + halfWidth + offsetAndSize.left,
            y: tne.y + halfHeight + offsetAndSize.top,
        },
        sw: {
            x: tsw.x + halfWidth + offsetAndSize.left,
            y: tsw.y + halfHeight + offsetAndSize.top,
        },
        se: {
            x: tse.x + halfWidth + offsetAndSize.left,
            y: tse.y + halfHeight + offsetAndSize.top,
        },
    };
};
//# sourceMappingURL=dom.js.map